// import { CreationMessage, messageFromSerializedObject } from '@luxtag/luxtag-sdk-ts';
import { concat } from 'lodash';
// import { NetworkType, PublicAccount, TransferTransaction } from 'nem2-sdk';
import { Vue } from 'vue-property-decorator';
import { IAsset, IAssetInfo, IAssetsStore, ITag, IUpdateTag } from './interface';

export const MUTATE_ASSET_RAW_HISTORY = 'MUTATE_ASSET_RAW_HISTORY';
export const MUTATE_ASSET_CREATION_INFO = 'MUTATE_ASSET_CREATION_INFO';
export const UPDATE_ASSET_RAW_HISTORY = 'UPDATE_ASSET_RAW_HISTORY';
export const UPDATE_TAG = 'UPDATE_TAG';
export const ADD_TAG = 'ADD_TAG';

export default {
    [MUTATE_ASSET_RAW_HISTORY](state: IAssetsStore, payload: IAsset) {
        // replace the whole transactions of an asset
        // state.assets[payload.publicKey] = payload.transactions;
        const creationTransaction = payload.transactions[payload.transactions.length - 1];
        if (creationTransaction) {
            // const message = messageFromSerializedObject(JSON.parse(creationTransaction.message.payload));
            // message.transactionInfo = creationTransaction.transactionInfo;
            // if (message instanceof CreationMessage) {
            //     const assetInfo: IAssetInfo = {
            //         message,
            //         timestamp: creationTransaction.deadline.value,
            //         signer: creationTransaction.signer!,
            //         recipient: creationTransaction.recipient,
            //     };
            //     const pubAccount = PublicAccount.createFromPublicKey(payload.publicKey, NetworkType.MIJIN_TEST);
            //     Vue.set(state.assetsCreationInfo, pubAccount.address.plain(), assetInfo);
            // }
        }

        Vue.set(state.assetsRawHistory, payload.publicKey, payload.transactions);
    },
    [UPDATE_ASSET_RAW_HISTORY](state: IAssetsStore, payload: IAsset) {
        // merge the transactions
        const mergedTx = concat(payload.transactions, state.assetsRawHistory[payload.publicKey]);
        // state.assets[payload.publicKey] = concat(payload.transactions, state.assets[payload.publicKey]);
        Vue.set(state.assetsRawHistory, payload.publicKey, mergedTx);
    },
    [UPDATE_TAG](state: IAssetsStore, payload: IUpdateTag) {
        state.tags.splice(payload.tagId, 1, payload.tag);
    },
    [ADD_TAG](state: IAssetsStore, payload: ITag) {
        state.tags.push(payload);
    },
};
